<template>
  <v-container :class="['blog-post']">
    <v-layout v-if="error" row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-alert :value="true">{{ error }}</v-alert>
      </v-flex>
    </v-layout>
    <v-layout v-if="post" row wrap :class="['blogposts-list']" align-space-between fill-height>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-card>
          <v-card-text>
            <div v-html="post.content" :class="['mb-4']" />
            <v-divider />
            <div v-html="$lang.postDetails(post.author.first_name, post.author.last_name, post.date, post.url)" :class="['mt-3', 'caption']" />
          </v-card-text>
        </v-card>
      </v-flex>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageBlogPost',
  mixins: [
    methods
  ],
  data () {
    return {
      error: null,
      post: null
    }
  },
  mounted () {
    this.getPost()
  },
  methods: {
    setPost (data) {
      this.post = data
      this.$nextTick(() => {
        document.querySelectorAll('.blog-post a').forEach(link => {
          link.classList.add('white--text')
        })
        document.querySelectorAll('.blog-post img').forEach(img => {
          img.classList.add('elevation-12')
        })
      })
    },
    getPost () {
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('blog', slug)
      if (cachedData) {
        return this.setPost(cachedData)
      }
      this.$http({
        url: this.getRoute('post').url,
        method: 'POST',
        data: {
          slug: this.$route.params.post
        }
      }).then(response => {
        const code = response.data.code
        if (code === 0) {
          const data = response.data.data.post.post
          this.setPost(data)
          this.cacheData(slug, 'blog', data)
        } else {
          this.error = this.$lang.errors[code]
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>
<style>
.blog-post img
{
  display: block;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/blog-post.vue